import clsx from 'clsx';
import styles from '../../RelatedParties.module.scss';
import { alertIcon, alertIconDisabled, caretRight } from '../../../../../../assets/hostedassets';
import { normalizeNameKey, toTitleCase } from '../../../../../../utils/utils';
import { getImage, HOLDING_PREFIX_EDGE_TYPES } from '../../relatedParty_constants';
import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';
import { formatShareholdingPercent, formatDesignationWithShareholding } from '../../../../../../utils/formatShareholdingPercent';

function FirstDegreeRow({ edgeType, isPDFReport, expandAll, entityEntry, handleAlertsClick, handleShowRelationsClick, isProbeEnabled }) {
    const shareholdingValue = entityEntry?.shareholdingPercentage;
    const detailsText = HOLDING_PREFIX_EDGE_TYPES.has(edgeType)
        ? formatShareholdingPercent(shareholdingValue, { prefix: 'Holding: ', hideWhenNull: true })
        : formatDesignationWithShareholding(entityEntry?.designation, shareholdingValue, { hideWhenNull: true });

    // Tooltip shows the RAW percentage (not the adaptive-precision one used in detailsText
    // above) so hovering reveals the exact underlying value regardless of display rounding.
    const rawPercentText = Number.isFinite(shareholdingValue) ? `${shareholdingValue}%` : '';
    const tooltipContent = [toTitleCase(entityEntry?.fromName) || '-', entityEntry?.designation, rawPercentText]
        .filter(Boolean)
        .join(' • ');

    return (
        <tr
            key={entityEntry?.fromKid}
            className={clsx(styles.FirstDegreeRow, styles.FirstDegreeRow_Hover)}
            data-rp-director={normalizeNameKey(entityEntry?.fromName)}
            data-rp-din={entityEntry?.identifier ?? entityEntry?.din ?? ''}
            onClick={() => {
                handleShowRelationsClick(entityEntry, edgeType);
            }}
        >
            <td className={styles.RowItem}>
                <div className={styles.EntityNameContainer}>
                    {!isPDFReport && (
                        <div
                            className={clsx(styles.Caret, {
                                [styles.Caret_Disabled]: !entityEntry?.rows?.length,
                                [styles.Caret_Expanded]: entityEntry?.rows?.length && (entityEntry.isExpanded || expandAll),
                            })}
                        >
                            <img
                                className={clsx(styles.CaretImg, {
                                    [styles.CaretImg_Rotate]: entityEntry.isExpanded || (expandAll && entityEntry?.rows?.length),
                                })}
                                src={caretRight}
                                alt="caret"
                                height={'12px'}
                            />
                        </div>
                    )}
                    <div className={styles.EntityNamePill}>
                        {!isPDFReport && (
                            <img
                                src={getImage(entityEntry?.type)}
                                alt="ent"
                                height={'14px'}
                                style={{
                                    marginTop: '2px',
                                }}
                            />
                        )}
                        <Tooltip content={tooltipContent} direction="top" contentCss={{ whiteSpace: 'nowrap' }} fitContent small usePortal>
                            <span className={styles.Text}>
                                <span className={styles.PersonName}>{toTitleCase(entityEntry?.fromName) || '-'}</span>
                            </span>
                        </Tooltip>
                    </div>
                </div>
            </td>

            <td className={styles.RowItem}>
                {detailsText ? (
                    <Tooltip content={tooltipContent} direction="top" contentCss={{ whiteSpace: 'nowrap' }} fitContent small usePortal>
                        <span className={styles.DetailsText}>{detailsText}</span>
                    </Tooltip>
                ) : (
                    <span className={styles.DetailsText}>{detailsText}</span>
                )}
            </td>

            <td className={styles.RowItem}>{/* {getRelationType(entityEntry?.edgeType, entityEntry?.type) || '-'} */}</td>

            <td className={styles.RowItem}>
                {/* <div className={styles.EntityNamePill}>
                    {toTitleCase(entityEntry?.toName) || '-'}
                </div> */}
            </td>

            <td className={styles.RowItem}>
                <div
                    className={clsx(styles.Risk, {
                        [styles.Risk_Severe]: entityEntry?.risk === 'SEVERE',
                        [styles.Risk_High]: entityEntry?.risk === 'HIGH',
                        [styles.Risk_Medium]: entityEntry?.risk === 'MEDIUM',
                        [styles.Risk_Low]: entityEntry?.risk === 'LOW',
                    })}
                >
                    {entityEntry?.risk && entityEntry?.risk !== 'null' ? toTitleCase(entityEntry?.risk) : 'NA'}
                </div>
            </td>

            {!isPDFReport && (
                <td className={styles.RowItem}>
                    {isProbeEnabled && !entityEntry?.alerts?.length ? (
                        <Tooltip
                            content="AICA can't fetch alerts for this"
                            direction="top"
                            contentCss={{ color: 'black', whiteSpace: 'nowrap' }}
                            fitContent
                            small
                            usePortal
                        >
                            <div className={clsx(styles.Alerts, styles.Alerts_Disabled)}>
                                <img
                                    src={alertIconDisabled}
                                    alt="alert"
                                    style={{
                                        margin: '0px 5px 2px 0',
                                    }}
                                />
                                <span>NA</span>
                            </div>
                        </Tooltip>
                    ) : (
                        <div
                            className={clsx(styles.Alerts, {
                                [styles.Alerts_Disabled]: !entityEntry?.alerts?.length,
                            })}
                            onClick={() => {
                                handleAlertsClick(entityEntry);
                            }}
                        >
                            <img
                                src={entityEntry?.alerts?.length ? alertIcon : alertIconDisabled}
                                alt="alert"
                                style={{
                                    margin: '0px 5px 2px 0',
                                }}
                            />
                            <span>{entityEntry?.alerts?.length} Alerts</span>
                        </div>
                    )}
                </td>
            )}
        </tr>
    );
}

export default FirstDegreeRow;
